<template>
  <div
    class="gap-20px p-20px relative flex h-full flex-col justify-start bg-white pt-[50px] md:pt-[55px] xl:pt-[60px]">
    <slot />
  </div>
</template>
